import React from 'react'

const ArrowIcon = ({ color = '#A5AEBE', width = '10', height = '17' }) => (
	<svg width={width} height={height} viewBox="0 0 10 17" xmlns="http://www.w3.org/2000/svg">
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M9.00398 8.84242C9.39451 8.4519 9.39451 7.81873 9.00398 7.42821L2.00648 0.430706C1.61596 0.0401802 0.982793 0.0401802 0.592269 0.430706C0.201744 0.82123 0.201744 1.4544 0.592269 1.84492L6.88266 8.13531L0.592269 14.4257C0.201744 14.8162 0.201744 15.4494 0.592269 15.8399C0.982793 16.2304 1.61596 16.2304 2.00648 15.8399L9.00398 8.84242Z"
			fill={color}
		/>
	</svg>
)

export default ArrowIcon
